/** https://stackoverflow.com/a/16436975/1328511 */
/** Compares arrays a and b at the 1st level
 * (nested object/arrays not checked for equality) */
export function arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.

    for (let i = a.length - 1; i >= 0; --i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}
